// extracted by mini-css-extract-plugin
module.exports = {"commentForm":"CommentForm_commentForm__2-bfJ","commentTextarea":"CommentForm_commentTextarea__1oUPN","commentButton":"CommentForm_commentButton__pArVt"};